import { gql } from "@apollo/client";
import { DIGITAL_WALLET_INFO } from "../fragments";

export const GET_DIGITAL_WALLET = gql`
  query digitalWallet {
    digitalWallet {
      ...digitalWalletInfo
    }
  }
  ${DIGITAL_WALLET_INFO}
`;
